import React from "react";
import {Avatar} from "antd";
import { useTranslation } from "react-i18next";


const NotificationItem = ({notification}) => {
  const { t } = useTranslation();
  const {icon, image, title, titleKey, time} = notification;
  const resolvedTitle = titleKey ? t(titleKey) : title;
  return (

    <li className="gx-media">
      <Avatar className="gx-size-40 gx-mr-3"
              alt={image}
              src={image}/>
      <div className="gx-media-body gx-align-self-center">
        <p className="gx-fs-sm gx-mb-0">{resolvedTitle}</p>
        <i className={`icon icon-${icon} gx-pr-2`}/> <span className="gx-meta-date"><small>{time}</small></span>
      </div>
    </li>
  );
};

export default NotificationItem;
